import { useSearchParams } from "react-router-dom";
import PageBanner from "@/components/feature/PageBanner";
import ProjectCard from "@/components/feature/ProjectCard";
import Reveal from "@/components/feature/Reveal";
import { projects, projectCategories } from "@/mocks/projects";

export default function Projects() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCategory = searchParams.get("category") || "전체";

  const filtered =
    activeCategory === "전체" ? projects : projects.filter((project) => project.category === activeCategory);

  const selectCategory = (category: string) => {
    const next = new URLSearchParams(searchParams);
    if (category === "전체") {
      next.delete("category");
    } else {
      next.set("category", category);
    }
    setSearchParams(next);
  };

  return (
    <>
      <PageBanner
        eyebrow="PROJECT"
        title="프로젝트"
        description="주거 공간부터 호텔, 상업 시설까지. 동우스톤의 소재가 실제로 적용된 공간을 실사 이미지로 소개합니다."
        image="https://readdy.ai/api/search-image?query=wide%20luxury%20interior%20space%20with%20marble%20flooring%20and%20stone%20finishes%2C%20elegant%20neutral%20palette%2C%20warm%20architectural%20lighting%2C%20high%20end%20design%20photography%2C%20expansive%20clean%20composition&width=1800&height=900&seq=stone-banner-projects&orientation=landscape"
        imageAlt="대리석 바닥으로 마감된 고급 실내 공간"
        current="프로젝트"
      />

      <section className="bg-background-50">
        <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
          <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
            <p className="text-sm text-foreground-600">
              총 <span className="font-medium text-primary-600">{filtered.length}</span>개의 시공 사례
            </p>
            <div className="flex flex-wrap gap-2">
              {projectCategories.map((category) => {
                const isActive = activeCategory === category;
                return (
                  <button
                    key={category}
                    type="button"
                    onClick={() => selectCategory(category)}
                    className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors ${
                      isActive
                        ? "border-primary-500 bg-primary-500 text-background-50"
                        : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                    }`}
                  >
                    {category}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
            {filtered.map((project, index) => (
              <Reveal key={project.id} delay={Math.min(index, 6) * 70}>
                <ProjectCard project={project} large={index % 3 === 0} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}